import { GET_PATIENTS_DETAILS, GET_PATIENTS_DETAILS_LOADING, GET_PATIENTS_DETAILS_RET } from "../Constants"

const initialState = {
    getPatientDetails: false,
    getPatientDetailsRet: false,
    getPatientDetailsLoading: true,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PATIENTS_DETAILS:
            return {   
                ...state,
                getPatientDetails: action.data,
                getPatientDetailsLoading: true
            }
        case GET_PATIENTS_DETAILS_RET:
            return {
                ...state,
                getPatientDetails: false,
                getPatientDetailsRet: action.data
            }
        case GET_PATIENTS_DETAILS_LOADING:
            return {
                ...state,
                getPatientDetailsRet: false,
                getPatientDetailsLoading: false
            }
        default: 
            return {
                ...state
            }
    }
}
    